import { FC, MutableRefObject } from 'react';
import { CloseIcon, WarningIcon } from '../../../assets/icons';
import {
  BookingTransition,
  getTransitionLabel,
} from '../../../utils/functions/bookingTransitions';
import styles from './OverlapWarningPopup.module.scss';

type OverlapWarningPopupProps = {
  transition: BookingTransition;
  closeRef: MutableRefObject<HTMLDivElement | null>;
  onClose: () => void;
};

const OverlapWarningPopup: FC<OverlapWarningPopupProps> = ({
  transition,
  closeRef,
  onClose,
}) => {
  return (
    <div
      className={styles.container}
      role="dialog"
      aria-label="Информация о наложении брони"
    >
      <div className={styles.header}>
        <div className={styles.title}>Внимание</div>
        <div
          className={styles.close}
          ref={closeRef}
          role="button"
          tabIndex={0}
          aria-label="Закрыть"
          onClick={onClose}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              onClose();
            }
          }}
        >
          <CloseIcon />
        </div>
      </div>
      <div className={styles.message}>
        <WarningIcon width="9" height="24" fill="#b91212" />
        <span>{getTransitionLabel(transition)}</span>
      </div>
    </div>
  );
};

export default OverlapWarningPopup;
